/**
 * src/components/directory-page/BusinessGrid.js
 *
 * Grilla reactiva de BusinessCards.
 * Props: { businesses: Signal<Array> }
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'
import { effect } from '@core/signal.js'

define('BusinessGrid', ({ businesses }) => {
    const grid = h('div', { className: 'biz-grid' })

    const empty = h('div', { className: 'biz-grid__empty' },
        h('span', { className: 'biz-grid__empty-icon' }, '🔍'),
        h('p', {}, 'No se encontraron negocios con ese criterio.')
    )

    effect(() => {
        const list = businesses.get()
        while (grid.firstChild) grid.removeChild(grid.firstChild)

        if (!list.length) {
            grid.appendChild(empty)
            return
        }
        list.forEach(biz => grid.appendChild(c('BusinessCard', biz)))
    })

    return grid
})
